// Tema base compartido
const baseTheme = {
  fonts: {
    primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: '"Courier New", Courier, monospace',
  },
  
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    xxl: '1.5rem',
    xxxl: '2rem',
  },
  
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    round: '50%',
  },
  
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
  },
  
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px',
  },
};

// Tema Claro
export const lightTheme = {
  ...baseTheme,
  colors: {
    primary: '#5B9BD5',
    primaryDark: '#4A8BC2',
    primaryLight: '#7BAEE0',
    secondary: '#6C757D',
    success: '#4CAF50',
    danger: '#E57373',
    warning: '#FFA726',
    info: '#29B6F6',
    
    // Backgrounds
    background: '#F5F7FA',
    backgroundLight: '#FFFFFF',
    backgroundDark: '#E8ECEF',
    
    // Text
    textPrimary: '#2C3E50',
    textSecondary: '#6C757D',
    textLight: '#95A5A6',
    
    // Borders
    border: '#E0E0E0',
    borderLight: '#F0F0F0',
    
    // Status colors
    paid: '#4CAF50',
    pending: '#FFA726',
    overdue: '#E57373',
    
    // Sidebar
    sidebarBg: '#FFFFFF',
    sidebarText: '#6C757D',
    sidebarActive: '#5B9BD5',
    sidebarHover: '#F5F7FA',
  },
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.15)',
  },
};

// Tema Oscuro
export const darkTheme = {
  ...baseTheme,
  colors: {
    primary: '#5B9BD5',
    primaryDark: '#4A8BC2',
    primaryLight: '#7BAEE0',
    secondary: '#8E9AAF',
    success: '#66BB6A',
    danger: '#EF5350',
    warning: '#FFA726',
    info: '#42A5F5',
    
    // Backgrounds
    background: '#0F1419',
    backgroundLight: '#1A1F2E',
    backgroundDark: '#0A0E14',
    
    // Text
    textPrimary: '#E8EAED',
    textSecondary: '#9BA3AF',
    textLight: '#6C7380',
    
    // Borders
    border: '#2D3748',
    borderLight: '#252D3A',
    
    // Status colors
    paid: '#66BB6A',
    pending: '#FFA726',
    overdue: '#EF5350',
    
    // Sidebar
    sidebarBg: '#1A1F2E',
    sidebarText: '#9BA3AF',
    sidebarActive: '#5B9BD5',
    sidebarHover: '#252D3A',
  },
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.3)',
    md: '0 4px 6px rgba(0, 0, 0, 0.3)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.4)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.5)',
  },
};

// Tema por defecto (mantener compatibilidad)
export const theme = lightTheme;
